import type { FunctionComponent } from 'react'

import styles from './bento-rectangle-testimonial.module.scss'
import { Markdown } from '@components/markdown'
import type { BentoPieceRectangleTestimonialFragment } from '@graphql/queries/GetBentoOne.graphql'
import { usePersonalizations } from '@lib/hooks/usePersonalizations'
import { renderTemplate } from '@lib/utils/text'
import variables, { type Variable } from '@styles/variables'

export const BentoRectangleTestimonial: FunctionComponent<Props> = ({
    heading = '',
    headingMd,
    headingColor = 'white',
    subHeading,
    subHeadingColor = 'futureFuscia',
    copy = '',
    copyColor = 'white',
    alignText = 'left',
    backgroundColor = 'darkGray',
}) => {
    const personalizations = usePersonalizations()

    return (
        <div
            className={styles.boxOne}
            style={{ backgroundColor: variables[backgroundColor as Variable] }}
        >
            <div className={`${styles.boxOneContent}`}>
                <div
                    className={`${styles.boxOneCopy} ${
                        alignText === 'center' ? styles.center : ''
                    } ${alignText === 'right' ? styles.right : ''}`}
                >
                    {heading && (
                        <div
                            className={`${styles.heading} ${
                                headingColor === 'gradient'
                                    ? styles.headinggradient
                                    : ''
                            }`}
                            style={{
                                color: variables[headingColor as Variable],
                            }}
                        >
                            {heading}
                        </div>
                    )}

                    {headingMd && (
                        <div
                            className={`${styles.heading} ${
                                headingColor === 'gradient'
                                    ? styles.headinggradient
                                    : ''
                            }`}
                            style={{
                                color: variables[headingColor as Variable],
                            }}
                        >
                            <Markdown
                                tag='h3'
                                typeStyle={{
                                    _: 'heading-xs',
                                    md: 'heading-md',
                                    lg: 'heading-lg',
                                }}
                                markdown={renderTemplate(
                                    headingMd,
                                    personalizations,
                                )}
                            />
                        </div>
                    )}

                    {subHeading && (
                        <div
                            className={`${styles.subheading} ${
                                subHeadingColor === 'gradient'
                                    ? styles.headinggradient
                                    : ''
                            }`}
                            style={{
                                color: variables[headingColor as Variable],
                            }}
                        >
                            {subHeading}
                        </div>
                    )}

                    {copy && (
                        <div className={styles.copy}>
                            <Markdown
                                tag='p'
                                typeStyle={{ _: 'body-md', md: 'body-md' }}
                                markdown={renderTemplate(
                                    copy,
                                    personalizations,
                                )}
                                color={variables[copyColor as Variable]}
                            />
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default BentoRectangleTestimonial

type Props = Omit<BentoPieceRectangleTestimonialFragment, 'sys' | 'type'> & {
    index?: number
}
